import React from "react";
import DA_SearchInputB2c from "../SearchInputB2c/SearchInputB2c.component";
import S from "./MiniSearchB2c.module.scss";

export const DA_MiniSearchB2c = () => (
    <div className={S.wrapper}>
        <DA_SearchInputB2c trapFocus />
    </div>
);
